export const START_PROCESS = 'Please click Start Process to push data into Xero'
